module.exports = __webpack_public_path__ + "media/images/svg-icon/search-a80ef2111767be8f4757137f15eee08b.svg";